// extracted by mini-css-extract-plugin
export default {"marginRight":"SearchBar_marginRight__l3tXx","searchBarStyle":"SearchBar_searchBarStyle__wNv66"};